import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../store/ApplicationState";
import ReferralRequest from "../components";
import { TabSessionDataDispatchTypes } from "../../../models/DispatchTypes/TabSessionStorage";
import { saveTabSessionStorageResp } from "../../../actions/TabSessionStorage";
import { TabData } from "../../../models/TabSessionStorage";
import { resetStates } from "../../../actions/Common";
import { RequestAuthorizationPayload } from "../../../models/RequestAuthorization";
import { requestAuthorization } from "../../../actions/RequestAuthorization";
import { EligibilityInformation } from "../../../models/CheckEligibility";
import { saveEligibilityInformation, saveReferralRequestor } from "../../../actions/ReferralRequest";
import { ReferralRequestor } from "../../../models/ReferralRequestor";

const mapStateToProps = ({
  TabSessionStorageState,
  requestAuthorizationState,
  eligibilityInformationState,
  referralRequestorState,
}: ApplicationState) => ({
  TabSessionStorage: TabSessionStorageState,
  referralSubmitData: requestAuthorizationState,
  eligibilityInformationData: eligibilityInformationState,
  referralRequestor: referralRequestorState,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<
    ApplicationState,
    Record<string, never>,
    TabSessionDataDispatchTypes
  >
) => {
  return {
    saveTabSessionStorage: (SessionData: TabData) => {
      dispatch(saveTabSessionStorageResp(SessionData));
    },
    resetStates: (actionType: string[]) => {
      dispatch(resetStates(actionType));
    },
    requestAuthorization: (payload: RequestAuthorizationPayload) => {
      dispatch(requestAuthorization(payload));
    },
    saveEligibilityInformation: (sessionData: EligibilityInformation) => {
      dispatch(saveEligibilityInformation(sessionData));
    },
    saveReferralRequestor: (sessionData: ReferralRequestor) => {
      dispatch(saveReferralRequestor(sessionData));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReferralRequest);
